module.exports = __webpack_public_path__ + "static/media/backbase.4a6a56e8.png";